/* eslint-disable */
import getClasses from './getClasses';

export default function containsClass(el, className) {
  return getClasses(el).some((c) => c === className);
}
